import React from 'react';
import './WhyUs.css';

const reasons = [
  {
    icon: 'fa-shield-halved',
    title: 'Trusted & Verified',
    desc: 'All listings are verified by our expert team to ensure authenticity and security.',
  },
  {
    icon: 'fa-bolt',
    title: 'Fast Process',
    desc: 'From search to keys in hand — we streamline every step of the journey.',
  },
  {
    icon: 'fa-headset',
    title: '24/7 Support',
    desc: 'Our agents are always available to guide you through every important decision.',
  },
  {
    icon: 'fa-tag',
    title: 'Best Prices',
    desc: 'We negotiate the best deals so you get maximum value for your investment.',
  },
];

export default function WhyUs() {
  return (
    <section className="why-us">
      <div className="why-container">
        <h2>Why Choose BricksNHome?</h2>
        <p className="why-sub">We make finding your dream home simple, fast, and transparent.</p>
        <div className="why-grid">
          {reasons.map((r, i) => (
            <div className="why-card" key={i}>
              <div className="why-icon">
                <i className={`fa ${r.icon}`} />
              </div>
              <h3>{r.title}</h3>
              <p>{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
